"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Componente primário de interação com o usuário
 */
var Radio = function Radio(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_react.default.createElement(_core.Radio, {
    color: color
  });
};

exports.Radio = Radio;
Radio.propTypes = {
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
};
Radio.defaultProps = {
  color: 'primary'
};
var _default = Radio;
exports.default = _default;